import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import { i18n } from 'config/locales';
import { formTypes } from 'config/formTypes';
import { ErrorList } from 'components/ErrorList';
import SectionNavigation from 'components/Section/shared/SectionNavigation';
import Contacts from 'components/Section/Foreign/Contacts';
import Travel from 'components/Section/Foreign/Travel';
import {
  DirectActivity,
  IndirectActivity,
  RealEstateActivity,
  FutureActivity,
CurrentActivity,
OnGoingSupport,
  BenefitActivity,
  Support,
} from 'components/Section/Foreign/Activities';
import {
  Advice,
  Family,
  Employment,
  Ventures,
  Conferences,
  Contact,
  Sponsorship,
  Political,
  Voting,
} from 'components/Section/Foreign/Business';
import { FOREIGN } from 'constants/sections';
import { rootSelectors } from '@redux/modules/selectors';
import Review from './Review';
import Intro from './Intro';
import SectionNotFound from '../shared/SectionNotFound';
import ForeignBusinessIntro from './Business/Intro';
import ForeignActivitiesIntro from './Activities/Intro';


const Foreign = function ({
  subsection, location, formType, isReview
}) {
  const subsectionLibrary = {
    intro: Intro,
    contacts: Contacts,
    'activities/intro': ForeignActivitiesIntro,
    'activities/direct': DirectActivity,
    'activities/indirect': IndirectActivity,
    'activities/realestate': RealEstateActivity,
    'activities/benefits': BenefitActivity,
    'activities/future': FutureActivity,
    'activities/current': CurrentActivity,
    'activities/ongoingsupport': OnGoingSupport,
    'activities/support': Support,
    'business/intro': ForeignBusinessIntro,
    'business/advice': Advice,
    'business/family': Family,
    'business/employment': Employment,
    'business/ventures': Ventures,
    'business/conferences': Conferences,
    'business/contact': Contact,
    'business/sponsorship': Sponsorship,
    'business/political': Political,
    'business/voting': Voting,
    travel: Travel,
    review: Review,
  };
  const form = formTypes[formType];
  const section = form.find((s) => s.key === FOREIGN);
  const flattenedSections = formTypes.reduceSubsections([section]);
  const subsectionClasses = `view view-${subsection.name || 'unknown'}`;
  const title = isReview && i18n.t('review.title');
  const para = isReview && i18n.m('review.para');

  return (
    <div className="section-view">
      {title && <h1 className="title">{title}</h1>}
      {para}

      <div className={subsectionClasses}>
        {isReview && (
          <div className="top-btns">
            <ErrorList />
          </div>
        )}

        <Switch>
          {flattenedSections.map((sub) => (
            <Route key={sub.key} path={sub.fullPath} component={subsectionLibrary[sub.name]} />
          ))}
          <Route component={SectionNotFound} />
        </Switch>

        <SectionNavigation currentPath={location.pathname} />
      </div>
    </div>
  );
};

/**
 * @param {import('types/state').RootState} state
 */
const mapStateToProps = (state) => ({
  subsection: state.section.subsection,
  isReview: rootSelectors.section.getIsSectionInReview(state),
  formType: rootSelectors.application.getFormType(state),
});

Foreign.propTypes = {
  subsection: PropTypes.object,
  location: PropTypes.object,
  formType: PropTypes.string,
  isReview: PropTypes.bool,
};

Foreign.defaultProps = {
  subsection: {},
  location: {},
};

export default connect(mapStateToProps)(Foreign);

export var ForeignSections = function () {
  return <Review />;
};
